"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonSnackBar = void 0;
var React = require("react");
var Icon_1 = require("../../Icons/Icon/Icon");
var SnackBar_1 = require("../SnackBar");
var ButtonSnackBar_styles_1 = require("./ButtonSnackBar.styles");
var ButtonSnackBar = /** @class */ (function (_super) {
    __extends(ButtonSnackBar, _super);
    function ButtonSnackBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { Visible: true };
        _this.handleOnClick = function () {
            if (_this.props.OnClick) {
                _this.props.OnClick().then(function () {
                    _this.setState({ Visible: false });
                });
            }
            else {
                _this.setState({ Visible: false });
            }
        };
        return _this;
    }
    ButtonSnackBar.prototype.render = function () {
        return (React.createElement(SnackBar_1.SnackBar, { Visible: this.state.Visible },
            React.createElement(ButtonSnackBar_styles_1.ContainerDiv, null,
                this.props.ButtonText,
                React.createElement(ButtonSnackBar_styles_1.IconContainerButton, { onClick: this.handleOnClick, title: this.props.ButtonText },
                    React.createElement(Icon_1.Icon, { Icon: this.props.ButtonIcon })))));
    };
    return ButtonSnackBar;
}(React.PureComponent));
exports.ButtonSnackBar = ButtonSnackBar;
